<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DataFormatter from '../../../../model/DataFormatter'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import OCECRatio from '../../../../model/OCECRatio'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'StatisticalAnalysisOCECRatio',
  routeInfo: {
    label: 'OC/EC比值'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, XYChart},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    chartType: 'line',
    stackType: 1
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, true, this.getFilterFactors)
      ]
    },
    downloadName: () => ''
  },
  methods: {
    getFilterFactors (siteDeviceFactors, siteDevice) {
      let siteDeviceFactorMap = siteDeviceFactors.reduce((map, factor) => {
        map[factor.factorId] = factor
        return map
      }, {})
      const siteDeviceId = siteDevice.id

      let {GROUPS, OC_EC_RATIO_UNIT} = OCECRatio
      siteDeviceFactors = GROUPS.reduce((list, groupObj) => {
        let {group} = groupObj
        let filterGroup = group.filter(group => siteDeviceFactorMap[group.factorId])

        if (filterGroup.length === group.length) {
          filterGroup.reduce((list, group) => {
            let factor = siteDeviceFactorMap[group.factorId]
            let {newId} = group

            list.push({
              id: newId,
              factorId: newId,
              name: factor.name,
              displayUnit: factor.displayUnit
            })
            return list
          }, list)

          let {ratioId, ratioName} = groupObj
          list.push({
            id: ratioId,
            factorId: ratioId,
            name: ratioName,
            displayUnit: OC_EC_RATIO_UNIT,
            tooltipShowUnit: false,
            siteDeviceId
          })
        }

        return list
      }, [])

      if (siteDeviceFactors.length >= 3 && !this.query.isMultipleIntegral) {
        siteDeviceFactors.push({
          ...OCECRatio.SPLIT_TIME
        })
      }

      return siteDeviceFactors
    },
    formatData (oDataListProp = 'tmpList', dataListProp = 'dataList') {
      console.time('format3')

      let {currentQuery} = this

      if (Object.keys(currentQuery).length === 0) {
        return
      }

      let {dimension, filterSiteMap} = this
      const dataMap = this.tmpList.reduce((map, data) => {
        map[data.dataTime] = data
        return map
      }, {})
      this.tmpList = Object.freeze(this.tmpList.concat(Object.values(this.noDataReasonMap).reduce((list, noDataReason) => {
        const {siteId} = noDataReason
        const siteConfig = filterSiteMap[siteId]

        if (siteConfig) {
          const {siteDeviceId} = noDataReason
          const siteDeviceConfig = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDeviceConfig) {
            const {reason} = noDataReason
            const dataTime = `${noDataReason.dataTime}:00:00`
            let data = dataMap[dataTime]

            if (data) {
              siteDeviceConfig.siteDeviceFactors.forEach(siteDeviceFactor => {
                const {factorId} = siteDeviceFactor
                const value = data[factorId]

                if (!Number.isFinite(value) && !value) {
                  data[factorId] = reason
                }
              })
            } else {
              list.push(siteDeviceConfig.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
                map[siteDeviceFactor.factorId] = reason
                return map
              }, {
                dataTime,
                siteId
              }))
            }
          }
        }

        return list
      }, [])).sort((a, b) => a.dataTime.localeCompare(b.dataTime)))

      DataFormatter.format.bind(this)(currentQuery, dimension === 0 ? currentQuery.factorIds : currentQuery.siteIds, (data, newData, dimensionIdProp1, ts, dataTime) => {
        let {seriesMap} = newData
        let dimensionIdsLen = dimensionIdProp1.length

        for (let i = 0; i < dimensionIdsLen; i++) {
          let dimensionId = dimensionIdProp1[i]
          let series = seriesMap[dimensionId]

          if (series) {
            let value = data[dimensionId]
            const newData = {
              ts,
              dataTime,
              isHaveIntegral: data.hasOwnProperty(dimensionId + 'IsHaveIntegral') && data[dimensionId + 'IsHaveIntegral'] === 1,
              flag: data.flag || null
            }

            if (Number.isFinite(value)) {
              newData.value = value
            } else if (value) {
              newData.noDataReason = value
            }

            series.push(newData)
          }
        }
      }, oDataListProp, dataListProp)

      // const {dataList} = this
      // this.noDataList.forEach(noData => {
      //   const {siteId} = noData
      //   const siteConfig = filterSiteMap[siteId]

      //   if (siteConfig) {
      //     const siteData = dataList.find(siteData => siteData.id === siteId)

      //     if (siteData) {
      //       const {siteDeviceId} = noData
      //       const siteDevice = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

      //       if (siteDevice) {
      //         const dataTime = `${noData.dataTime}:00:00`
      //         const ts = new Date(dataTime).getTime()
      //         const {seriesMap} = siteData

      //         siteDevice.siteDeviceFactors.forEach(siteDeviceFactor => {
      //           const {factorId} = siteDeviceFactor
      //           const dataMap = seriesMap[factorId]
      //           let data = dataMap[dataTime]

      //           if (!data) {
      //             data = dataMap[dataTime] = {
      //               ts,
      //               dataTime
      //             }
      //           }

      //           data.noDataReason = noData.reason
      //         })
      //       }
      //     }
      //   }
      // })

      console.timeEnd('format3')
    },
    getData () {
      this.changeLoadStatus(true)

      const {currentQuery} = this

      Promise.all([
        this.$api.StatisticalAnalysis.getOCEC(currentQuery),
        this.$api.NoData.getNoDataListBySite(currentQuery)
      ]).then(this.setAllDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(dataList)
      this.formatData()
    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    getSelectedNames (dimension, params) {
      return dimension === 0 ? Object.values(params[dimension ^ 1]).reduce((map, config) => {
        map[config.name] = !/^o/i.test(config.id)

        return map
      }, {}) : null
    }
  },
  watch: {
    filterFactorMap: {
      immediate: true,
      handler (filterFactorMap) {
        this.selectedNames = this.query.factorIds.reduce((list, factorId) => {
          let factor = filterFactorMap[factorId]

          if (factor && !/^o/i.test(factor.id)) {
            list.push(factor.name)
          }

          return list
        }, [])
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/16OCEC-Ratio/index.vue